import getPlatformFromInappId from "./getPlatformFromInappId";

const findPriceWithTier = (tiersList, tier, id) => {
    let tiersObj;
    const platform = getPlatformFromInappId(id);

    tiersObj = tiersList.find(obj => obj.tier === tier);
    return tiersObj?.[platform]?.USD || tiersObj?.ios?.USD || null;
};

export default findPriceWithTier;